<template>
  <div>
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="dialog = true"
    >
      Filters
    </el-button>
    <el-dialog title="Filters" :visible.sync="dialog" width="500px">
      <el-input type="text" v-model="name" placeholder="Name" />
      <el-input type="text" v-model="email" placeholder="E-mail" class="mt10" />
      <el-date-picker
        v-model="date_range"
        type="daterange"
        class="mt10"
        unlink-panels
        range-separator="-"
        start-placeholder="Start date"
        end-placeholder="End date"
        :picker-options="dateRangeOptions"
        format="d MMMM yyyy"
        value-format="yyyy-MM-dd"
        @change="filter()"
      ></el-date-picker>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      name: '',
      email: '',
      date_range: ''
    }
  },

  methods: {
    ...mapActions('newsletter', ['read', 'setPage']),
    ...mapMutations('newsletter', ['setPage']),

    filter() {
      this.setPage(1)
      let filter_data = {
        name: this.name,
        email: this.email,
        date_start: this.date_range[0],
        date_end: this.date_range[1]
      }
      localStorage.setItem('newsletter_filter', JSON.stringify(filter_data))
      this.read()
    },

    clear() {
      this.read()
      this.name = ''
      this.email = ''
      this.date_range = ''
      let ls = localStorage.removeItem('newsletter_filter')
    }
  }
}
</script>
